import { defineComponent as _defineComponent } from 'vue'
import { defineAsyncComponent, onBeforeUnmount, onMounted } from 'vue';

interface Props {
  propClass?: string;
  showCloseIcon?: boolean;
  typeModalError?: boolean;
  closeOnClickOutside?: boolean;
  closeButtonId?: string;
  isScrollLocked?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'modal-center',
  props: {
    propClass: { default: '' },
    showCloseIcon: { type: Boolean },
    typeModalError: { type: Boolean },
    closeOnClickOutside: { type: Boolean },
    closeButtonId: { default: 'test-close-button' },
    isScrollLocked: { type: Boolean, default: false }
  },
  emits: [
  'close-modal',
  'on-keydown-enter',
  'is-mounted'
],
  setup(__props: any, { emit }) {

const props = __props as { propClass: string, showCloseIcon?: boolean, typeModalError?: boolean, closeOnClickOutside?: boolean, closeButtonId: string, isScrollLocked: boolean };





const IconClose = defineAsyncComponent(() => import('@white-label-icon/icon-close'));


/**
 * Handles the outside click event.
 */
function onOutsideClick() {
  if (props.closeOnClickOutside) {
    closeModal();
  }
}

/**
 * Emits an event to close the modal
 */
function closeModal() {
  emit('close-modal');
}

/**
 * Handles the keydown event and triggers the `on-keydown-enter` event
 * if the 'Enter' key is pressed.
 *
 * @param event - The keydown event object
 */
function keydownListener(event: KeyboardEvent) {
  if (event.key === 'Enter') {
    emit('on-keydown-enter');
  }
}

onMounted(() => {
  window.addEventListener('keydown', keydownListener);
  // We need to check the original mounted hook because we use a lot of slots
  emit('is-mounted');
});

onBeforeUnmount(() => {
  window.removeEventListener('keydown', keydownListener);
});

return { __sfc: true,props, emit, IconClose, onOutsideClick, closeModal, keydownListener }
}

})